function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M38 17.72a.86.86 0 0 0-.11-.24l-.06-.07a.74.74 0 0 0-.12-.13l-.08-.07h-.25a.84.84 0 0 0-.27 0h-5.63V6.72a.94.94 0 0 0-.93-.94H13.46a.94.94 0 0 0-.94.94V17H7a.87.87 0 0 0-.28.05h-.08l-.11.05-.06.05a.18.18 0 0 0-.07.05.66.66 0 0 0-.14.15v.06a1 1 0 0 0-.15.5v19.16A.94.94 0 0 0 7 38h30a.94.94 0 0 0 .94-.93V17.94a.78.78 0 0 0 .06-.22zM29.61 7.65v13.49L22 25.52l-7.61-4.38V7.65zm6.5 28.48H7.89V19.55l13.65 7.85a.91.91 0 0 0 .93 0l8.08-4.65v.05l5.56-3.24z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M25.43 9.93h-7.74a.94.94 0 1 0 0 1.87h7.74a.94.94 0 0 0 0-1.87zM22.77 13.26h-5.08a.93.93 0 1 0 0 1.86h5.08a.93.93 0 1 0 0-1.86z"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 44 44"
    }, props), _ref, _ref2, _ref3)
  );
};

export default SvgComponent;